/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Searchusers1Inputs */

const en_settings_searchusers1 = /** @type {(inputs: Settings_Searchusers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Users`)
};

/**
* | output |
* | --- |
* | "Search Users" |
*
* @param {Settings_Searchusers1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_searchusers1 = /** @type {((inputs?: Settings_Searchusers1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Searchusers1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_searchusers1(inputs)
});
export { settings_searchusers1 as "settings_searchUsers" }